import React from "react";
import ReactApexChart from "react-apexcharts";

const UsageChart = ({ title, data }) => {
  const categories = Object.keys(data).map((key) =>
    key === "" ? "(empty)" : key,
  );
  const values = Object.values(data);

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        distributed: true,
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories,
      labels: {
        rotate: -45,
        style: { fontSize: "12px" },
      },
    },
    yaxis: {
      labels: {
        style: { fontSize: "12px" },
      },
    },
    title: {
      text: title,
      align: "center",
      style: {
        fontSize: "16px",
        fontWeight: 600,
        color: "#2563eb",
      },
    },
    colors: values.map((value) => {
      if (value >= 15) return "#059669";
      if (value >= 10) return "#3B82F6";
      if (value >= 5) return "#F59E0B";
      return "#064B9AFF";
    }),
  };

  const chartSeries = [{ name: title, data: values }];

  return (
    <div className="w-full p-4 md:w-1/3">
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={250}
      />
    </div>
  );
};

export default UsageChart;
